import { IntentsCommandList } from '~/features/command-lists'

import { useFilterMutator } from '../hooks'

export function IntentFilterControl() {
  const { onSelect, selection } = useFilterMutator()
  return <IntentsCommandList selected={selection} onSelect={onSelect} />
}
